<div class="modal-header">
  <h4 class="modal-title" translate>Select Company</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()">
    <fa-icon [icon]="faTimes"></fa-icon>
  </button>
</div>

<div class="modal-body">
  <div *ngIf="CompaniesList && CompaniesList.length > 0; else noCompanies">
    <p class="text-muted mb-3" translate>Please select a company to continue:</p>

    <div class="table-responsive">
      <table class="table table-hover table-light-header table-striped">
        <thead>
          <tr>
            <th translate>Company Name</th>
            <th translate>User Name</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of CompaniesList; let i = index">
            <td class="custom-table-width">
              {{ item.companyname }}
            </td>
            <td class="custom-table-width">
              {{ item.username }}
            </td>
            <td>
              <button class="btn btn-sm btn-primary" (click)="selectCompany(item)" [disabled]="isSaving" translate>
                Select
              </button>
              <!-- <spinner *ngIf="isSaving" class="ms-2" diameter="20"></spinner> -->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <ng-template #noCompanies>
    <div class="alert alert-info text-center">
      <fa-icon [icon]="faSpinner" [spin]="true" *ngIf="isSaving"></fa-icon>
      <span *ngIf="!isSaving" translate>No companies available for selection.</span>
    </div>
  </ng-template>
</div>

<div class="modal-footer">
  <button class="btn btn-light mr-2" id="confirm-cancel-btn" (click)="cancel()" [disabled]="isSaving" translate>
    Cancel
  </button>
</div>